import React from "react";
import { useWallet } from "../context/WalletContext";

// Detect if we're on mobile without an injected wallet
function isMobileNoWallet() {
  if (typeof window === "undefined") return false;
  const ua = navigator.userAgent || "";
  const mobile = /iPhone|iPad|iPod|Android/i.test(ua);
  return mobile && !window.ethereum;
}

// Open Nav inside MetaMask's in-app browser (mobile deep link)
function metaMaskDeepLink() {
  const host = typeof window !== "undefined" ? window.location.host : "navbook.app";
  return `https://metamask.app.link/dapp/${host}`;
}

export default function WalletModal() {
  const {
    open,
    setOpen,
    connectDemo,
    connectMetaMask,
    hasMetaMask,
    error,
  } = useWallet();
  if (!open) return null;
  const mobileNoWallet = isMobileNoWallet();

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center"
      style={{ background: "rgba(18,21,26,0.28)" }}
      onClick={() => setOpen(false)}
      data-testid="wallet-modal-overlay"
    >
      <div
        className="page-enter"
        style={{
          background: "var(--paper-raised)",
          border: "1px solid var(--ink)",
          padding: 40,
          width: 460,
          maxWidth: "92vw",
        }}
        onClick={(e) => e.stopPropagation()}
        data-testid="wallet-modal"
      >
        <div className="serif" style={{ fontSize: 32, lineHeight: 1.05 }}>
          Connect.
        </div>
        <div
          className="grotesque"
          style={{
            fontSize: 13,
            color: "var(--ink-muted)",
            marginTop: 8,
            letterSpacing: "0.01em",
          }}
        >
          Robinhood Chain · 4663 · ETH gas · USDG quote
        </div>

        <div style={{ marginTop: 28, display: "flex", flexDirection: "column", gap: 12 }}>
          {hasMetaMask ? (
            <button
              className="btn-primary"
              onClick={connectMetaMask}
              data-testid="wallet-metamask-connect"
              style={{ justifyContent: "space-between" }}
            >
              <span>{window.ethereum?.isRabby ? "Rabby" : window.ethereum?.isCoinbaseWallet ? "Coinbase Wallet" : "MetaMask"}</span>
              <span style={{ opacity: 0.7, fontSize: 12 }}>Injected</span>
            </button>
          ) : mobileNoWallet ? (
            <a
              href={metaMaskDeepLink()}
              className="btn-primary"
              data-testid="wallet-metamask-mobile"
              style={{
                justifyContent: "space-between",
                textDecoration: "none",
              }}
            >
              <span>Open in MetaMask</span>
              <span style={{ opacity: 0.7, fontSize: 12 }}>Mobile</span>
            </a>
          ) : (
            <a
              href="https://metamask.io/download/"
              target="_blank"
              rel="noreferrer"
              className="btn-outline"
              data-testid="wallet-metamask-install"
              style={{
                justifyContent: "space-between",
                textDecoration: "none",
              }}
            >
              <span>Install MetaMask</span>
              <span style={{ opacity: 0.6, fontSize: 12 }}>metamask.io</span>
            </a>
          )}

          {/* Also offer mobile deep-link even on desktop with an injected wallet? */}
          {hasMetaMask && (
            <div style={{ fontSize: 11, color: "var(--ink-muted)", letterSpacing: "0.02em", textAlign: "center" }}>
              Rabby and Coinbase Wallet are auto-detected via the same button.
            </div>
          )}

          <button
            className="btn-outline"
            onClick={connectDemo}
            data-testid="wallet-demo-connect"
            style={{ justifyContent: "space-between" }}
          >
            <span>Demo wallet</span>
            <span style={{ opacity: 0.6, fontSize: 12 }}>Preview only</span>
          </button>
        </div>

        {error && (
          <div
            data-testid="wallet-error"
            style={{
              marginTop: 20,
              borderTop: "1px solid var(--down)",
              paddingTop: 12,
              color: "var(--down)",
              fontSize: 12.5,
            }}
          >
            {error}
          </div>
        )}

        <button
          className="btn-ghost"
          onClick={() => setOpen(false)}
          style={{ marginTop: 28 }}
          data-testid="wallet-close"
        >
          Close
        </button>
      </div>
    </div>
  );
}
